import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { listOrdersProductsDispatches, modifyOrdersProductsDispatch } from "@/api/orders-products-dispatches";
import Inr from "@/components/Inr/index.vue";
import router from "@/router";
import { viewInvoice, getOrdersDispathById, updateOrdersDispath, addAdditionalCharges } from "@/api/orders-dispatches";
import { AdminModule } from "@/store/modules/admin";
import { isAdmin, isUnitManager, isSuperAdmin, isInvoiceManager } from "@/common";
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.list = [];
    this.listLoading = false;
    this.loadingForRequestApproval = false;
    this.loadingForApprove = false;
    this.loadingForReject = false;
    this.loadingForPreview = false;
    this.loggedInAdmin = null;
    this.formData = {
      id: null,
      status: "",
      tdsAmount: 0
    };
    this.rejectDialogFormVisible = false;
    this.approveDialogFormVisible = false;
    // private dispatchInfo: IOrdersDispatchData;
    this.dispatchInfo = null;
    this.showRequestApprovalButton = false;
    this.showApproveButton = false;
    this.showRejectButton = false;
    this.ordersDispatchId = 0;
    this.showPreviewButton = false;
    this.loadingForCharges = false;
    // Add Charges dialog state
    this.chargesDialogVisible = false;
    this.chargesFormData = {
      totalInstallationCharge: 0,
      daliDriverConfigCharges: 0,
      engravingCharges: 0
    };
    this.rules = {
      rejectReason: {
        required: true,
        message: "This field is required",
        trigger: "blur"
      }
    };
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    console.log("loggedInAdmin", this.loggedInAdmin);
    const id = this.$route.params && this.$route.params.id;
    this.ordersDispatchId = parseInt(id);
    this.getList(this.ordersDispatchId);
  }
  async getList(ordersDispatchId) {
    try {
      this.listLoading = true;
      // get products in dispatch
      const data = await listOrdersProductsDispatches(ordersDispatchId);
      for (const item of data) {
        item.isDisabled = true;
        item.maxQuantity = item.quantity;
      }
      this.list = data;
      // get dispatch info
      const info = await getOrdersDispathById(ordersDispatchId);
      // editing flag for terms of delivery
      if (info.status === "Request Approval") {
        info.editingTermsOfDelivery = false;
        info.modifiedTermsOfDelivery = info.termsOfDelivery;
      }
      // assign
      this.dispatchInfo = info;
      // set tds amount
      this.formData.tdsAmount = this.dispatchInfo.tdsAmount;
      // show action buttons if status is pending and logged in user is admin or invoice manager
      const dateToCompare = this.$moment().subtract(24, "h").format("YYYY-MM-DDTHH:mm:ss.SSS");
      switch (this.dispatchInfo.status) {
        case "Request Approval":
          this.showRequestApprovalButton = false;
          this.showPreviewButton = isSuperAdmin() || isAdmin() || isInvoiceManager();
          this.showApproveButton = isSuperAdmin() || isAdmin() || isInvoiceManager();
          this.showRejectButton = isSuperAdmin() || isAdmin() || isInvoiceManager();
          break;
        case "Approved":
          this.showRequestApprovalButton = false;
          this.showApproveButton = false;
          this.showPreviewButton = false;
          // show reject button if duration after approval is less than 24 hrs compare with ackDate
          if (this.dispatchInfo.ackDate) {
            if (this.$moment(dateToCompare).isBefore(this.$moment(this.dispatchInfo.ackDate, "YYYY-MM-DDTHH:mm:ss.SSS"))) {
              // although eway is generated but it is after ack Date
              this.showRejectButton = true;
            }
          } else {
            // eway not generated so showing the reject button
            this.showRejectButton = true;
          }
          break;
        case "Pending":
          this.showRequestApprovalButton = isUnitManager();
          this.showApproveButton = false;
          this.showPreviewButton = false;
          this.showRejectButton = false;
          break;
        default:
          this.showApproveButton = false;
          this.showRejectButton = false;
          this.showRequestApprovalButton = false;
          this.showPreviewButton = false;
          break;
      }
      // update dispatch ID for saving form
      this.formData.id = ordersDispatchId;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  showAddChargesButton() {
    if (!this.dispatchInfo || !this.loggedInAdmin || !this.loggedInAdmin.roles) {
      return false;
    }
    const isInvoiceManager = this.loggedInAdmin.roles.includes("Invoice Manager");
    const isSuperAdmin = this.loggedInAdmin.roles.includes("Super Admin");
    const isDispatchInRequestApproval = this.dispatchInfo.status === "Request Approval";
    return (isInvoiceManager || isSuperAdmin) && isDispatchInRequestApproval;
  }
  validateForm(action = "Reject") {
    this.$refs.formData.validate(valid => {
      if (valid) {
        switch (action) {
          case "Request Approval":
            this.sendForApproval();
            break;
          case "Approve":
            this.approveForm();
            break;
          case "Reject":
            this.rejectForm();
            break;
          default:
            break;
        }
      } else {
        return false;
      }
    });
  }
  async sendForApproval() {
    this.formData.status = "Request Approval";
    await updateOrdersDispath(this.formData.id, this.formData);
    router.push("/orders-dispatches/list");
  }
  async approveForm() {
    this.approveDialogFormVisible = false;
    this.formData.status = "Approved";
    this.formData.invoiceManagerId = this.loggedInAdmin.id;
    await updateOrdersDispath(this.formData.id, this.formData);
    router.push("/orders-dispatches/list");
  }
  async rejectForm() {
    this.rejectDialogFormVisible = false;
    this.formData.status = "Rejected";
    this.formData.invoiceManagerId = this.loggedInAdmin.id;
    await updateOrdersDispath(this.formData.id, this.formData);
    router.push("/orders-dispatches/list");
  }
  async toggleDisable(index, row, action = null) {
    this.list[index].isDisabled = !row.isDisabled;
    if (action === "update") {
      await modifyOrdersProductsDispatch(row.id, {
        quantity: row.quantity
      });
      this.$notify({
        type: "success",
        title: "Success",
        message: "Quantity updated",
        duration: 2000
      });
      // if all quantity to be removed, delete table row
      if (row.quantity === row.maxQuantity) {
        this.list.splice(index, 1);
      }
    } else {
      this.list[index].quantity = row.maxQuantity;
    }
  }
  async downloadInvoice(id = 0) {
    // get invoice url
    this.listLoading = true;
    const data = await viewInvoice(id);
    if (data && data.url) {
      window.open(data.url, "_blank");
      // const filename = "invoice_" + id + ".pdf";
      // this.downloadFile(data.url, filename);
    } else {
      this.$message({
        message: "Failed to generate invoice",
        type: "error"
      });
    }
    this.listLoading = false;
  }
  _isSuperAdmin() {
    return isSuperAdmin();
  }
  async saveTermsOfDelivery() {
    this.dispatchInfo.editingTermsOfDelivery = false;
    const updated = await updateOrdersDispath(this.dispatchInfo.id, {
      termsOfDelivery: this.dispatchInfo.modifiedTermsOfDelivery
    });
    if (updated) {
      this.dispatchInfo.termsOfDelivery = updated.termsOfDelivery;
      this.dispatchInfo.modifiedTermsOfDelivery = updated.termsOfDelivery;
    }
  }
  editTermsOfDelivery() {
    this.dispatchInfo.editingTermsOfDelivery = true;
    this.dispatchInfo.modifiedTermsOfDelivery = this.dispatchInfo.termsOfDelivery;
  }
  // Opens the Add Charges dialog, resetting the form fields
  // Opens the Add Charges dialog with previously saved values (if any)
  openChargesDialog() {
    this.chargesFormData = {
      totalInstallationCharge: this.dispatchInfo.totalInstallationCharge || 0,
      daliDriverConfigCharges: this.dispatchInfo.daliDriverConfigCharges || 0,
      engravingCharges: this.dispatchInfo.engravingCharges || 0
    };
    this.chargesDialogVisible = true;
  }
  // Handles saving the charges - currently just logs the data
  async handleSaveCharges() {
    try {
      var _ref, _ref2, _ref3;
      this.loadingForCharges = true;
      const updated = await addAdditionalCharges(this.dispatchInfo.id, this.chargesFormData);
      // persist saved values so re-opening the dialog shows them
      this.dispatchInfo.totalInstallationCharge = (_ref = updated && updated.totalInstallationCharge) !== null && _ref !== void 0 ? _ref : this.chargesFormData.totalInstallationCharge;
      this.dispatchInfo.daliDriverConfigCharges = (_ref2 = updated && updated.daliDriverConfigCharges) !== null && _ref2 !== void 0 ? _ref2 : this.chargesFormData.daliDriverConfigCharges;
      this.dispatchInfo.engravingCharges = (_ref3 = updated && updated.engravingCharges) !== null && _ref3 !== void 0 ? _ref3 : this.chargesFormData.engravingCharges;
      this.$notify({
        type: "success",
        title: "Success",
        message: "Charges saved",
        duration: 2000
      });
      this.chargesDialogVisible = false;
    } catch (error) {
      this.$message({
        message: "Failed to save charges",
        type: "error"
      });
    } finally {
      this.loadingForCharges = false;
    }
  }
};
default_1 = __decorate([Component({
  name: "DispatchInfo",
  components: {
    Inr
  }
})], default_1);
export default default_1;